import { Edit, ReferenceInput, SimpleForm, TextInput } from "react-admin";

const CashierEdit = () => (
  <Edit>
    <SimpleForm>
      <ReferenceInput source="id" reference="users" />
      <TextInput source="pseudo" label="Pseudo" />
      <TextInput source="full_name" label="Full name" />
      <TextInput source="email" label="Email" />
    </SimpleForm>
  </Edit>
);

export default CashierEdit;
